import AbstractComponent from './AbstractComponent';
import { OPENED } from 'core/Classes';

const SESSION_KEY = 'seen-announcement';

class AnnouncementBar extends AbstractComponent {
  constructor() {
    super(...arguments);
  }

  bind() {
    super.bind();
    this.handleClickClose = this.handleClickClose.bind(this);
  }

  destroy() {
    sessionStorage.setItem(SESSION_KEY, 'yes');
    this.events(false);
    this.ui.$element.remove();
  }

  initializeBeforeEvents() {
    if (sessionStorage.getItem(SESSION_KEY) == 'yes') {
      this.destroy();
    } else {
      this.ui.$element.classList.add(OPENED);
    }
  }

  getUI() {
    const ui = super.getUI();
    ui.$close = document.querySelector('.announcement-bar__close');
    return ui;
  }

  events(listen) {
    const listener = listen ? 'addEventListener' : 'removeEventListener';
    this.ui.$close[listener]('click', this.handleClickClose);
  }

  handleClickClose() {
    this.destroy();
  }
}

export default AnnouncementBar;
